import { render } from "./DashboardExport.vue?vue&type=template&id=615d8ea7&ts=true"
import script from "./DashboardExport.vue?vue&type=script&lang=ts"
export * from "./DashboardExport.vue?vue&type=script&lang=ts"

import "./DashboardExport.vue?vue&type=style&index=0&id=615d8ea7&lang=scss"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__